import React from 'react'
import {
  type AttributeManagementStepVersion,
  AttributeManagementTypeEnum,
} from '../../../types/attributeManagement.types'
import LLMPromptTemplateRunManualTestModal from './LLMPromptTemplateRunManualTestModal'
import SnowflakeQueryInputRunManualTestModal from './SnowflakeQueryInputRunManualTestModal'
import PipelineRunManualTestModal from './PipelineRunManualTestModal'
import QasRunManualTestModal from './QasRunManualTestModal'
import RegexRunManualTestModal from './RegexRunManualTestModal'
import PublishRunManualTestModal from './PublishRunManualTestModal'
import PublishToSnowflakeRunManualTestModal from './PublishToSnowflakeRunManualTestModal'

interface RunManualTestModalProps {
  type: AttributeManagementTypeEnum
  onClose: () => void
  stepVersion: AttributeManagementStepVersion
}

export const RunManualTestModal: React.FC<RunManualTestModalProps> = ({
  onClose,
  stepVersion,
  type,
}) => {
  if (type === AttributeManagementTypeEnum.LLMPromptTemplate) {
    return (
      <LLMPromptTemplateRunManualTestModal
        onClose={onClose}
        stepVersionId={stepVersion.id}
        expectedFields={stepVersion.attributes.properties.map(
          (property: any) => property.propertyName
        )}
      />
    )
  }
  if (type === AttributeManagementTypeEnum.SnowflakeQueryInput) {
    return (
      <SnowflakeQueryInputRunManualTestModal onClose={onClose} stepVersionId={stepVersion.id} />
    )
  }
  if (type === AttributeManagementTypeEnum.Pipeline) {
    return <PipelineRunManualTestModal onClose={onClose} stepVersionId={stepVersion.id} />
  }
  if (type === AttributeManagementTypeEnum.QAS) {
    return (
      <QasRunManualTestModal
        onClose={onClose}
        stepVersionId={stepVersion.id}
        expectedFields={stepVersion.attributes.components.map((component: any) => component.name)}
      />
    )
  }
  if (type === AttributeManagementTypeEnum.Regex) {
    return (
      <RegexRunManualTestModal
        onClose={onClose}
        stepVersionId={stepVersion.id}
        expectedFields={stepVersion.attributes.mutations.map(
          (mutation: any) => mutation.inputField
        )}
      />
    )
  }
  if (type === AttributeManagementTypeEnum.Publish) {
    return (
      <PublishRunManualTestModal
        onClose={onClose}
        stepVersionId={stepVersion.id}
        expectedFields={stepVersion.attributes.data.map((data: any) => data.campField)}
      />
    )
  }
  if (type === AttributeManagementTypeEnum.PublishToSnowflake) {
    return (
      <PublishToSnowflakeRunManualTestModal
        onClose={onClose}
        stepVersionId={stepVersion.id}
        expectedFields={stepVersion.attributes.columnMappings
          .map((column: any) => column.campField)
          .filter((campField: any) => campField !== null)}
      />
    )
  }
  return <div>FAIL</div>
}

export default RunManualTestModal
